export const thuocTinh = {
  sections: {
    list: { title: 'Product attributes' },
    detail: { title: 'Attribute' },
    giaTri: { title: 'Attribute values' },
  },
  titles: { add: 'Add attribute', edit: 'Edit attribute', create: 'Create attribute' },
  columns: {
    code: 'Code',
    summary: 'Attribute name',
    note: 'Description',
    loaiInput: 'Input type',
    moTa: 'Description',
    status: 'Status',
    soGiaTri: 'Values',
    soHangHoa: 'Products',
    nguoiTao: 'Created by',
    ngayTao: 'Created',
    ngayCapNhat: 'Updated',
    onOffAction: 'On/Off',
  },
  filter: {
    searchPlaceholder: 'Search by code / name...',
    textDetailTitle: 'Detailed filter',
  },
  filters: {
    hintSection: 'Hint',
    hintBody: 'Manage product attributes (Color, Size, Capacity...).',
    statusAll: 'All statuses',
    loaiInputAll: 'All types',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  loaiInput: {
    text: 'Free text',
    select: 'Dropdown',
    number: 'Number',
  },
  actions: {
    pause: 'Deactivate',
    activate: 'Activate',
    addGiaTri: 'Add value',
    editGiaTri: 'Edit value',
    xoaGiaTri: 'Delete value',
    quanLyGiaTri: 'Manage values',
  },
  messages: {
    loadError: 'Could not load attributes.',
    deleteSuccess: 'Attribute deleted.',
    noData: 'No attributes.',
    listSummary: '{count} items',
    saveSuccess: 'Attribute saved.',
    statusChanged: 'Status updated.',
    createSuccess: 'Attribute created.',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected attributes?',
    bulkDeleteSuccess: 'Deleted {count} attributes',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} failed.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No attribute selected',
    hhCount: '{count} P',
    gtCount: '{count} V',
    giaTriSaveSuccess: 'Value saved.',
    giaTriDeleteSuccess: 'Value deleted.',
    giaTriNoData: 'No values yet. Add the first one.',
    giaTriTrung: 'This value is already in the list.',
    giaTriHintAdd: 'After saving the attribute, you can add values (Red, Size L...).',
    giaTriInUse: 'Value is used by {count} products, cannot delete.',
  },
  form: {
    ten: 'Attribute name',
    maThuocTinh: 'Attribute code',
    moTa: 'Description',
    loaiInput: 'Input type',
    thuTu: 'Order',
    giaTri: 'Value',
  },
  validation: {
    tenRequired: 'Please enter attribute name.',
    giaTriRequired: 'Please enter value.',
  },
  placeholders: {
    formTitle: 'Attribute',
    formBody: '',
    ten: 'Enter attribute name (e.g. Color)',
    maThuocTinh: 'Leave empty to auto-generate',
    nhapGiaTri: 'Type value and press Enter (e.g. Red, Blue...)',
  },
  dropdown: {
    empty: '— Select attribute —',
    giaTriEmpty: '— Select value —',
  },
}
